import IconVueJs from "./VueJs";
import IconHtml from "./Html";
import IconCss from "./Css";
import IconScss from "./Scss";
import IconBootstrap from "./Bootstrap";
import IconTailwindCss from "./TailwindCss";
import IconJQuery from "./JQuery";
import IconJavascript from "./Javascript";
import IconIonic from "./Ionic";
import IconNuxtJs from "./NuxtJs";
import IconMySql from "./MySql";
import IconPhp from "./Php";
import IconLaravel from "./Laravel";
import IconVuetify from "./Vuetify";
import IconAdobeXD from "./AdobeXD";
import IconAdobeIllustrator from "./AdobeIllustrator";
import IconFigma from "./Figma";
import IconDefault from "./Default";
import {FaEye, FaEyeSlash} from "react-icons/fa";
import IconPhotoshop from "./Photoshop";
import IconReactJs from "./ReactJs";
import IconRedux from "./Redux";
import IconNextJs from "./NextJs";
import IconPinia from "./Pinia";
import IconNestJs from "./Nest";
import IconMongoDB from "./MongoDB";

const Icon = ({name, color}) => {
  switch (name) {
    case 'Html':
      return <IconHtml/>;
    case 'Css':
      return <IconCss/>;
    case 'Scss':
      return <IconScss/>;
    case 'Bootstrap':
      return <IconBootstrap/>;
    case 'Tailwind Css':
      return <IconTailwindCss/>;
    case 'JQuery':
      return <IconJQuery/>;
    case 'Javascript':
      return <IconJavascript/>;
    case 'Vue Js':
      return <IconVueJs/>;
    case 'React Js':
      return <IconReactJs/>;
    case 'Redux':
      return <IconRedux/>;
    case 'Next Js':
      return <IconNextJs/>;
    case 'Firebase':
      return <IconVueJs/>;
    case 'Vuetify':
      return <IconVuetify/>;
    case 'Ionic':
      return <IconIonic/>;
    case 'Nuxt Js':
      return <IconNuxtJs/>;
    case 'Pinia':
      return <IconPinia/>;
    case 'MySql':
      return <IconMySql/>;
    case 'Php':
      return <IconPhp/>;
    case 'Laravel':
      return <IconLaravel/>;
    case 'Nest Js':
        return <IconNestJs/>;
    case 'MongoDB':
        return <IconMongoDB/>;
    case 'Figma':
      return <IconFigma/>;
    case 'Adobe XD':
      return <IconAdobeXD/>;
    case 'Adobe Illustrator':
      return <IconAdobeIllustrator/>;
    case 'Illustrator':
      return <IconAdobeIllustrator/>;
    case 'Photoshop':
      return <IconPhotoshop/>;
    case 'More':
      // return <FaRegCircle color={color}/>;
      return <FaEye color={color}/>;
    case 'Less':
      // return <FaRegDotCircle color={color}/>;
      return <FaEyeSlash color={color}/>;
    default:
      return <IconDefault/>;
  }
}

export default Icon;
